import { ShieldCheck, Download, RefreshCw } from "lucide-react";
import { ChapterHeading } from "../ChapterHeading";
import { Reveal } from "../motion/Reveal";
import { BuyButton } from "../BuyButton";
import { PRICE_LABEL } from "../../config/pricing";

const INCLUDED = [
  "100 difficult management situations",
  "Warm, Balanced and Firm versions of every message",
  "Email subject + face-to-face opener for each",
  "117-page professionally designed PDF",
  "Instant download after checkout",
];

export function Pricing() {
  return (
    <section id="pricing" className="border-t border-line bg-surface/60 py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <ChapterHeading
          index="08"
          eyebrow="Pricing"
          title={
            <>
              Stop rewriting difficult messages{" "}
              <em className="font-normal">from scratch.</em>
            </>
          }
        />
        <Reveal delay={0.1} className="mt-14">
          <div className="grid grid-cols-1 overflow-hidden rounded-2xl border border-line bg-white shadow-[0_40px_80px_-50px_rgba(20,19,17,0.35)] lg:grid-cols-2">
            <div className="border-b border-line p-8 sm:p-10 lg:border-b-0 lg:border-r">
              <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-faint">
                SayIt Manager Edition
              </p>
              <ul className="mt-8 space-y-4">
                {INCLUDED.map((item) => (
                  <li
                    key={item}
                    className="flex items-start gap-3 text-sm leading-relaxed text-ink"
                  >
                    <span className="mt-[7px] h-1.5 w-1.5 shrink-0 rotate-45 bg-brand" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
            <div className="flex flex-col justify-between gap-10 p-8 sm:p-10">
              <div>
                <div className="flex items-end gap-3">
                  <span
                    data-testid="pricing-price-display"
                    className="font-display text-6xl font-light tracking-tight text-ink"
                  >
                    {PRICE_LABEL}
                  </span>
                  <span className="pb-2 font-mono text-[11px] uppercase tracking-[0.25em] text-faint">
                    Launch price
                  </span>
                </div>
                <p className="mt-4 text-sm text-smoke">
                  One-time payment. No subscription.
                </p>
              </div>
              <div>
                <BuyButton
                  testid="pricing-cta-button"
                  source="pricing"
                  label="Get SayIt now"
                  withPrice={false}
                  className="w-full sm:w-auto"
                />
                <p className="mt-4 flex items-center gap-2 text-[13px] text-faint">
                  <Download className="h-3.5 w-3.5" />
                  Download instantly after checkout.
                </p>
                <div className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-1.5 text-[12px] text-faint">
                  <span className="inline-flex items-center gap-1.5">
                    <ShieldCheck className="h-3.5 w-3.5" /> Secure checkout by Lemon Squeezy
                  </span>
                  <span className="inline-flex items-center gap-1.5">
                    <RefreshCw className="h-3.5 w-3.5" /> Yours to keep, forever
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
